import { BacksolveSourceRow } from 'api/models/BacksolveSourceRow';

// When the table is read-only (allocation final, or PDF export capture, which
// always forces read-only), rows with no weighting are hidden from the rendered
// view. The full row list is left untouched for saving/diffing.
const getVisibleSourceRows = (rows: BacksolveSourceRow[], isDisabled: boolean): BacksolveSourceRow[] =>
  (isDisabled ? rows.filter(row => Number(row.weighting) > 0) : rows);

export default getVisibleSourceRows;
